import { get, httpDelete, post, put } from '../../utils/http';

export const fetchAllProjectAiChatThreads = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat`);

export const fetchProjectAiChatThread = ({ accountId, branchId, projectId, threadId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat/${threadId}`);

export const submitFeedbackProjectAiChat = ({
  accountId,
  branchId,
  projectId,
  threadId,
  questionId,
  rating,
  feedbackComment
}) =>
  post(
    `/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat/${threadId}/feedback?questionId=${questionId}`,
    { rating, feedbackComment }
  );

export const renameProjectAiChatThread = ({ accountId, branchId, projectId, threadId, newName }) =>
  put(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat/${threadId}/rename`, { newName });

export const createNewProjectAiChat = ({ accountId, branchId, projectId }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat/new`);

export const deleteProjectAiChatThread = ({ accountId, branchId, projectId, threadId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat/${threadId}`);
